import { getCurrentYear } from '~/utils/datetime';

export const optionsType = [
    {
        name: 'Ăn Uống',
        icon: <i className="fa-solid fa-utensils"></i>,
    },
    {
        name: 'Chùa',
        icon: <i className="fa-solid fa-vihara"></i>,
    },
    {
        name: 'Khách sạn',
        icon: <i className="fa-solid fa-hotel"></i>,
    },
    {
        name: 'Phí BOT',
        icon: <i className="fa-solid fa-road"></i>,
    },
    {
        name: 'Vé / Phí DL',
        icon: <i className="fa-solid fa-ticket"></i>,
    },
    {
        name: 'Xăng',
        icon: <i className="fa-solid fa-gas-pump"></i>,
    },
    {
        name: 'Xe',
        icon: <i className="fa-solid fa-car"></i>,
    },
    {
        name: 'Khác',
        icon: <i className="fa-solid fa-money-bill"></i>,
    },
];

export const optionsDay = (() => {
    const list = [];
    for (let i = 1; i < 32; i++) {
        list.push({
            name: i.toString().padStart(2, '0'),
        });
    }
    return list;
})();

export const optionsMonth = (() => {
    const list = [];
    for (let i = 1; i < 13; i++) {
        list.push({
            name: i.toString().padStart(2, '0'),
        });
    }
    return list;
})();

export const optionsYear = (() => {
    const currentYear = parseInt(getCurrentYear());
    const list = [];
    for (let i = currentYear - 2; i < currentYear + 3; i++) {
        list.push({
            name: i.toString().padStart(4, '0'),
        });
    }
    return list;
})();

export const optionsHour = (() => {
    const list = [];
    for (let i = 1; i < 25; i++) {
        list.push({
            name: i.toString().padStart(2, '0'),
        });
    }
    return list;
})();

export const optionsMinute = (() => {
    const list = [];
    for (let i = 1; i < 61; i++) {
        list.push({
            name: i.toString().padStart(2, '0'),
        });
    }
    return list;
})();
